import SmartCard from "./SmartCard/SmartCard";
import {useMediaQuery} from "@mui/material";
import {fnLocalizeFilter} from "../../../services/localize.service";
import {useGlobalContext} from "../../../services/context.service";
import {BoxContainer} from "../../Common/SmartCardFlip";


export default function DriverCards() {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();
    /* Отображаем QR только если разрешение менее 1024 */
    const matches = useMediaQuery('(max-width:1024px)');


    return <>
        {matches
            ? <SmartCard />
            : <BoxContainer>{fnLocalizeFilter(locale, "_lang.module.cards.qr.notMatchResolution")}</BoxContainer>}
    </>
}
